import { configureStore } from '@reduxjs/toolkit'
import { ToastSlice } from './Slices/ToastSlice'

export const store = configureStore({
  reducer: {
    toast:ToastSlice.reducer
  },
})